import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { AnalyticsAPI } from '@shared/types/api';

export type Timeframe = '7d' | '14d' | '30d' | '90d' | '180d' | '365d' | 'all' | 'custom';

export interface UseAdminAnalyticsParams {
  timeframe: Timeframe;
  city?: string;
  startDate?: string; // ISO date string (YYYY-MM-DD)
  endDate?: string;   // ISO date string (YYYY-MM-DD)
}

/**
 * Hook to fetch advanced analytics data (admin only)
 */
export function useAdminAnalytics(params: UseAdminAnalyticsParams) {
  return useQuery({
    queryKey: ['admin-analytics', params.timeframe, params.city, params.startDate, params.endDate],
    queryFn: async (): Promise<AnalyticsAPI.GetAnalyticsResponse> => {
      const searchParams = new URLSearchParams();
      searchParams.set('timeframe', params.timeframe);
      if (params.city && params.city !== 'all') {
        searchParams.set('city', params.city);
      }
      if (params.timeframe === 'custom' && params.startDate && params.endDate) {
        searchParams.set('startDate', params.startDate);
        searchParams.set('endDate', params.endDate);
      }
      return api.get(`/admin/analytics?${searchParams.toString()}`);
    },
    enabled: params.timeframe !== 'custom' || (!!params.startDate && !!params.endDate),
  });
}

